import { keyframes as a, css as e } from "styled-components";
import { Theme as r } from "./themes/index.js";
const l = a`
  0%, 15%, 85%, 100% {
    transform: translateY(-100%);
  }

  20%, 80% {
    transform: translateY(0);
  }
`, c = a`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`, y = a`
  from {
    margin-left: 0;
    transform: translateX(0%);
  }

  to {
    transform: translateX(-100%)
  }
`, s = a`
  from {
    opacity: 1;
  }

  to {
    opacity: 0.5;
  }
`, n = 0.75, d = ({
  animate: t = !1,
  disableBackground: o = !1
}) => e`
  animation: ${t && e`
    ${n}s ${s}
    alternate infinite
  `};

  background: ${o ? "none" : `rgb(${r.colors.Golf})`};
`, m = (t, o) => `
  animation-delay: ${n * t / o}s;
`, k = (t, o) => e`
  ${m(t, o)}
`;
export {
  c as rotationKeyframes,
  d as skeletonFadeAnimation,
  k as skeletonItemAnimationDelay,
  m as skeletonItemAnimationDelayString,
  l as slideInOut,
  y as sparkKeyframes
};
